import type { FC, ReactNode } from "react";
import "./CharacterCounter.css";

type Props = {
	current: number;
	max: number;
	prefix?: ReactNode;
	suffix?: ReactNode;
	id?: string;
};

const CharacterCounter: FC<Readonly<Props>> = ({
	current,
	max,
	prefix,
	suffix,
	id,
}) => {
	return (
		// biome-ignore lint/a11y/useSemanticElements: this status includes optional block content and is not form output
		<div id={id} className="character-counter" role="status" aria-live="polite">
			{prefix && <div>{prefix}</div>}
			<span className="visually-hidden">Character count: </span>
			{current} of {max} characters used
			{suffix && <div>{suffix}</div>}
		</div>
	);
};

export default CharacterCounter;
